export default {
  /*
   * Devuelve las noticias
   */
  index(params) {
    return Vue.http.get('passenger/news_item', {params}).then(
      response => response.data
    )
  }
}
